export enum FireReportMode {
  FIRE_REPORT = 1,
  EVACUATION_REPORT = 2,
}
